const isLight = (hex) => {
    const rgb = parseInt(hex, 16);   // convert rrggbb to decimal
    const r = (rgb >> 16) & 0xff;  // extract red
    const g = (rgb >> 8) & 0xff;  // extract green
    const b = (rgb >> 0) & 0xff;  // extract blue
    return (
        0.213 * r +
        0.715 * g +
        0.072 * b >
        255 / 2
    );
};

export default {
    isLight
};